import { withExtension, withoutExtension, withoutPage, withPage } from '../utils';
export function registerPage(ctx, name, value) {
    ctx.dispatch(withPage(name, value));
}
export function unregisterPage(ctx, name) {
    ctx.dispatch(withoutPage(name));
}
export function registerExtension(ctx, name, value) {
    ctx.dispatch(withExtension(name, value));
}
export function unregisterExtension(ctx, name, reference) {
    ctx.dispatch(withoutExtension(name, reference));
}
//# sourceMappingURL=components.js.map